import styled from 'styled-components';
import { getDefaultForegroundColor, getDefaultTextColor } from '../theme';

export const ListElement = styled.div`
    padding: 0;
    position: relative;
    text-align: left;
    box-sizing: border-box;
    outline: none;
    width: 100%;
    color: ${getDefaultTextColor};
    background-color: ${getDefaultForegroundColor};
    overflow-y: auto;
`;
